import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-tab-header',
  styleUrl: 'tabs.css',
  shadow: true,
})
export class TabHeader {
  @Prop() name: string;

  render() {
    return (
      <li role="presentation" class="heading">
        <a role="tab" href={`#${this.name}`} class="heading-link">
          <slot />
        </a>
      </li>
    );
  }
}
